export class StringUtils {
  private constructor() {}

  public static lowerCaseFirstLetter(text: string): string {
    const firstChar = text[0];

    if (firstChar === undefined) {
      return text;
    }

    return `${firstChar.toLocaleLowerCase()}${text.substring(1)}`;
  }

  public static upperCaseFirstLetter(text: string): string {
    const firstChar = text[0];

    if (firstChar === undefined) {
      return text;
    }

    return `${firstChar.toLocaleUpperCase()}${text.substring(1)}`;
  }

  public static padLeft(
    text: string,
    desiredLength: number,
    padString: string = '0'
  ): string {
    let paddedText = text;

    while (paddedText.length < desiredLength) {
      paddedText = padString + paddedText;
    }

    return paddedText;
  }
}
